export default {
  certificatePath: (_store, getters) => (trackingId, context) => {
    const params = { trackingId: trackingId }
    return getters.getLocalizedPath('orderShow', params, context)
  }
}
